import script from "./BalTooltipV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTooltipV2.vue?vue&type=script&setup=true&lang=ts"

import "./BalTooltipV2.vue?vue&type=style&index=0&id=549c074c&lang=css"

const __exports__ = script;

export default __exports__